import { render, staticRenderFns } from "./sso-lti.vue?vue&type=template&id=8b64875c&scoped=true&"
import script from "./sso-lti.ts?vue&type=script&lang=ts&"
export * from "./sso-lti.ts?vue&type=script&lang=ts&"
import style0 from "./sso-lti.scss?vue&type=style&index=0&id=8b64875c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b64875c",
  null
  
)

export default component.exports